const ENDPOINT = 'POSTreplacesong';
function postReplaceSong(gateway, params = {}) {
    return gateway.get(postReplaceSong.endpoint, params);
}
postReplaceSong.endpoint = ENDPOINT;

export { postReplaceSong as default };
//# sourceMappingURL=postReplaceSong.js.map
